<template >
  <div>
    <v-container> 
      <v-row justify="center">
        <div class="mx-5 mb-5" v-for="service in items" :key="service.id">
          <service :service="service" v-on:delete="showDelete" v-on:save="SaveService"></service>
        </div>
      </v-row>
    </v-container>
    <v-dialog
      v-if="selectedElement"
      v-model="selectedOpen"
      justify-center
      max-width="350px"
    >
      <v-card color="grey lighten-4">
        <v-toolbar dark color="red">
          <v-card-title>Delete {{selectedElement.serviceName}}?</v-card-title>
        </v-toolbar>
        <v-card-actions justify-space-around>
          <v-btn dark color="grey" @click="cancel">Cancel</v-btn>
          <v-btn color="error" @click="DeleteService(selectedElement)">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import service from "../service/service.vue";
import axios from "axios";
export default {
  props: ["items"],
  components: {
    service
  },
  data: () => ({
    selectedElement: null,
    selectedOpen: false
  }),
  methods: {
    cancel(){
      this.selectedOpen = false;
      this.selectedElement = null;
    },
    showDelete(service) {
      const open = () => {
        this.selectedElement = service;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
    },

    DeleteService(service) {
      // let index = this.items.indexOf(service);
      // alert(index);
      // this.services.splice(index, 1);
      // this.selectedElement = {};
      // this.selectedOpen = false;

      let mutation = `mutation deleteService($id: String!) {
            deleteService(serviceID: $id) {
               id
                                serviceName
                                duration
                                price
                                companyId
            }
          }`;

      axios
        .post("/graphql", {
          query: mutation,
          variables: {
            id: service.id.toString()
          }
        })
        .then(res => {
          if (res.data.data.deleteService) {
            let index = this.items.indexOf(service);
            this.items.splice(index, 1);
            this.selectedOpen = false;
            this.selectedElement = {};
            this.showSuccess(
              `${res.data.data.deleteService.serviceName} has been deleted`
            );
          }
        })
        .catch(error => console.log(error));
    },
    SaveService(service) {
      let localService = { ...service };
      localService.duration = this.convertStringToSecond(localService.duration);

      let mutation = `mutation saveService($service: SaveService!) {
                                saveService(service: $service) {
                                id
                                serviceName
                                duration
                                price
                                companyId
                                }
                            }`;

      axios
        .post("/graphql", {
          query: mutation,
          variables: { service: localService }
        })
        .then(res => {
          if (res.data.data != null && res.data.data.saveService != null)
            this.showSuccess(`${res.data.data.saveService.serviceName} saved`);
        })
        .catch(error => this.showError(error.message));
    },
    convertStringToSecond(str) {
      if (str == null) return;
      var p = str.split(":"),
        s = 0,
        m = 1;

      while (p.length > 0) {
        s += 60 * m * parseInt(p.pop(), 10);
        m *= 60;
      }
      return s;
    }
  }
};
</script>

<style>
</style>
